var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"default-active":_vm.current,"mode":_vm.mode},on:{"select":_vm.clickMenu}},_vm._l((_vm.data),function(item,index){return _c('el-menu-item',{key:index,attrs:{"index":item.path}},[_vm._v(_vm._s(item.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }